<template>  
<sui-page>
  <sui-page-header />
  <sui-page-contents>
    <sui-grid v-show="showGrid" ref="grid" :multiselect="multiselect" :showCellLines="true" :columns="gridColumns0" :pageable="false" :filtable="true" :sortable="true" :dataset="'dataset0'" :initialPagesize="10" />    
    <ui-button class="my-button" :disabled="true" @click="onShowToggle">show/hide</ui-button>
    <ui-button class="my-button" @click="onInitData">initData</ui-button>
    <ui-button class="my-button" @click="onSetData">setData</ui-button>
    <ui-button class="my-button" @click="onSetDataGrid">setDataGridAPI</ui-button>
    <ui-button class="my-button" @click="onSetValue">setEditable</ui-button>    
    <ui-button class="my-button" @click="onAdd">add</ui-button>
    <ui-button class="my-button" @click="onAddRemove">remove/add</ui-button>
    <ui-button class="my-button" @click="onRemove">remove</ui-button>
    <ui-button class="my-button" @click="onReset">reset</ui-button>
    <ui-button class="my-button" @click="onClear">clear</ui-button>
    <ui-button class="my-button" @click="onSelect">select</ui-button>
    <ui-button class="my-button" @click="onRemove2">onRemove2</ui-button>
    <ui-button class="my-button" @click="onGetComponent">getComponent</ui-button>
    <ui-button class="my-button" @click="onHideColumn">hide column</ui-button>
    <ui-button class="my-button" @click="onTogglePanel">toggle panel</ui-button>
  </sui-page-contents>
</sui-page>
</template>
<script>  
  let cellsalign = 'right';

  import BasePage from '~cm/components/BasePage';

  export default {    
    name: 'KitchenSink',
    extends: BasePage,
    data() {
      return {        
        isShow: true,
        multiselect: true,
        showGrid: true,
        stateOptionList: [
          {
            type: 'complete',
            key: 'complete',
            clickable: 'true',
            label: '완료'
          },
          {
            type: 'complete',
            key: 'before-complete',
            clickable: 'true',
            label: '완료전'
          },
          {
            key: 'cancel',
            type: 'cancel',
            label: '취소'
          },
          {
            key: 'waiting',
            type: 'waiting',
            label: '대기'
          },
        ],
        myToolTip: 'my tool tip',
        multiSelectOptions: [{
            key: 'm1',
            label: 'aulti1',
          },
          {
            key: 'm2',
            label: 'bulti2',
          },
          {
            key: 'm3',
            label: 'culti3',
          },
          {
            key: 'm4',
            label: 'dulti4',
          },
          {
            key: 'm5',
            label: 'eulti5',
          },
        ],
        multiSelected: [],
        selectedUser: {
          userName: '',
          epid: '',
        },
        rangeDate: {
          start: "2019-11-10",
          end: '2019-11-15'
        },
        rangeDateString: null,
        pageUsePriodStartDatetime: new Date(),
        // pageUsePriodStartDatetime: "2000-01-01",
        pageUsePriodFinishDatetime: "2100-10-10",
        cellEditorMap: {},
        customOpitonList: [{
          key: '',
          label: 'AAA'
        }, ],
        selected: {
          md: {
            key: '',
            label: ''
          },
          smd: {
            key: '',
            label: ''
          },
          code: {
            key: '',
            label: ''
          },
          lang: {
            key: '',
            label: ''
          },
          yn: {
            key: '',
            label: ''
          },
          custom: {
            key: '개발',
            label: ''
          },
          customlang: {
            key: '',
            label: ''
          },
        },
        customOptions: [{
            key: 'D',
            label: '개발'
          },
          {
            key: 'F',
            label: '완료'
          },
        ],
        mdDisabled: false,
        pageName: '',
        pagePopupYn: '',
        checked: false,        
      };
    },
    mounted() {
      // this.onSetData();
      // this.dataset0.setRawData(newData);
      this.onInitData();
      // this.dataset0.$on('data-changed', (e) => {
      //   console.log(e);
      // })
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata',
      datafields: [
        {
          "name": "badge",
          "type": "string",
          "map": "badge"
        },
        {
          "name": "button",
          "type": "string",
          "map": "button"
        },
        {
          "name": "buttonlist",
          "type": "object",
          "map": "buttonlist"
        },
        {
          "name": "checkbox",
          "type": "string",
          "map": "checkbox"
        },
        {
          "name": "datepicker",
          "type": "string",
          "map": "datepicker"
        },
        {
          "name": "label2",
          "type": "string",
          "map": "label2"
        },
        {
          "name": "multiselectbox",
          "type": "string",
          "map": "multiselectbox"
        },
        {
          "name": "rangedatepicker",
          "type": "string",
          "map": "rangedatepicker"
        },
        {
          "name": "timepicker",
          "type": "string",
          "map": "timepicker"
        },        
        {
          "name": "selectbox",
          "type": "string",
          "map": "selectbox"
        },                
        {
          "name": "segmentbox",
          "type": "string",
          "map": "segmentbox"
        },
        {
          "name": "statebutton",
          "type": "object",
          "map": "statebutton"
        },
        {
          "name": "textfield",
          "type": "string",
          "map": "textfield"
        },
        {
          "name": "textarea",
          "type": "string",
          "map": "textarea"
        },
        {
          "name": "tooltiplabel",
          "type": "object",
          "map": "tooltiplabel"
        },
        {
          "name": "textfieldwithlabel",
          "type": "object",
          "map": "textfieldwithlabel"
        },
        {
          "name": "textfieldwithbutton",
          "type": "string",
          "map": "textfieldwithbutton"
        },
        {
          "name": "editable",
          "type": "string",
          "map": "editable"
        },
        {
          "name": "disable",
          "type": "string",
          "map": "disable"
        },
        {
          "name": "dataset-row-id",
          "type": "string",
          "map": "dataset-row-id"
        },
        {
          "name": "filterselectbox",
          "type": "string",
          "map": "filterselectbox"
        },
        {
          "name": "visibility",
          "type": "string",
          "map": "visibility"
        },
        {
          "name": "treeitem",
          "type": "object",
          "map": "treeitem"
        },
      ]
    }],
    methods: {
      onTogglePanel() {
        this.isShow = !this.isShow;
      },
      onClicked() {
        this.myToolTip = 'tooltip changed';
      },
      onCodeLoaded(optionsList) {
        optionsList.push({
          key: 'N',
          label: 'NN'
        });
      },
      datasetUpdate(delta) {
        console.log(delta);
      },
      onTestClicked() {
        this.dataset0.data[0]['pageId'] = 'TEST';
      },
      onRangeChanged(value) {        
        console.log(value);
      },
      onGridButtonClicked(btn, dataRow) {
        utils.messageBox('information', '버튼이 클릭되었습니다. 엔터를 누르세요', `label: ${btn.label}`, null);        
      },
      onGridStateClicked(stateOption, dataRow) {
        utils.messageBox('information', '버튼이 클릭되었습니다. 엔터를 누르세요', `label: ${stateOption.type}`, null);        
      },
      onChangeMode() {
        // this.$refs.multiSelect.activate();
        // this.$refs.grid.getCellEditor(0, 'pageName').getComponentInstance().setEditable(true);
        this.$refs.grid.setMode('label');
      },
      checkEditableName(rowData, columnName, dataset, grid) {
        if (rowData['pageUseYn'] === 'Y') {
          return true
        }
        return false;
      },
      checkEditableState(rowData, columnName, dataset, grid) {
        if (rowData['deleteYn'] === 'Y') {
          return true
        }
        return false;
      },      
      onTextFieldWithBtnClicked(event, dataRow) {
        // console.log(dataRow);
      },
      rowSpan(row, col, value) {
        // console.log(value);
        if (value === 'Y') {
          return 2;
        }
        return 1;
      },
      focusTextfield(button, dataRow, rowIndex, columnName) {        
        const targetColumnName = 'pageName';
        this.$refs.grid.setFocus(rowIndex, targetColumnName);
      },
      focusSelectbox(button, dataRow, rowIndex, columnName) {        
        const targetColumnName = 'pageStatusCode';
        this.$refs.grid.setFocus(rowIndex, targetColumnName);
      },
      onShowToggle() {
        this.showGrid = !this.showGrid;
      },
      onInitData() {
        const newData = [];
        const baseStr = JSON.stringify(this.localdata0[0]);
        for (let i = 0; i < 3000; i++) {
            const copiedData = JSON.parse(baseStr);
            copiedData.button = `btn(${i})`;
            if (i === 0)  {
              copiedData.rangedatepicker = '';            
            } else if (i === 1) {
              copiedData.rangedatepicker = '~2019-10-10';
            } else if (i === 2) {
              copiedData.rangedatepicker = '2019-05-05~';
            }
            if (i % 2) {
              copiedData.buttonlist[0].type = 'link';
            } else {
              copiedData.buttonlist[0].type = 'label';
            }
            copiedData.treeitem.depth = i % 4;
            newData.push(copiedData);
        }
        if (this.newData) {
          this.newData.splice(0, this.newData.length);
        }
        this.newData = newData;
      },
      onSetData() {
        this.dataset0.setRawData(this.newData, {preventBackup: false});        
      },
      onSetDataGrid() {
        const newData = _.clone(this.newData[0]);
        newData.editable = 'N';
        this.dataset0.setRawData([newData, _.clone(this.newData[1])]);
      },
      onSetValue() {
        this.dataset0.setData(0, 'editable', 'N');
      },
      checkEditableFunction(rowData, columnName, dataset, grid) {
        return rowData['editable'] === 'Y';
      },
      checkDisabledFunction(rowData, columnName, dataset, grid) {
        return rowData['disable'] === 'Y';
      },
      checkVisibilityFunction(rowData, columnName, dataset, grid) {
        return rowData['visibility'] === 'Y';
      },
      onAlign(align) {
        cellsalign = align;
        this.$refs.grid.update();
      },
      onTextfiledButtonClick(e) {
        console.log(e);
      },
      onAdd() {
        const row = _.clone(this.dataset0.data[0]);
        row.selectbox = 'F';
        row.checkbox = 'N';
        this.dataset0.addRows([row], true);
        console.log(this.dataset0.getSelectedIndexes());
      },
      onRemove() {
        const selected = this.dataset0.getSelectedIndexes();
        this.dataset0.deleteRows(selected);
        console.log(this.dataset0.getSelectedIndexes());
      },
      onAddRemove() {
        this.onRemove();
        this.onAdd();
      },
      onReset() {
        this.dataset0.reset();
        // this.dataset0.data = [];
        console.log(this.dataset0.getSelectedIndexes());
      },
      onClear() {
        // this.$refs.grid.getJqxGrid().removeAllCellEditor();
        // this.$refs.grid.getJqxGrid().destroy();        
        // this.newData.splice(0, this.newData.length);
        this.dataset0.setRawData([]);
        // this.$refs.grid.getJqxGrid().updateGrid([]);
        // this.$refs.grid.$destroy();
      },
      onSelect() {
        this.dataset0.setSelectedIndexes([1, 2, 3]);
        console.log(this.dataset0.getSelectedIndexes());
      },
      onRemove2() {
        this.dataset0.deleteRows([1]);
        console.log(this.dataset0.getSelectedIndexes());
      },
      onGetComponent() {
        const editor = this.$refs.grid.getCellEditor(0, 'badge');
        console.log(editor);
      },
      selectboxFilterFuntion(optionList, rowIndex, rowData, columnName, value, dataset, grid) {
        return _.filter(optionList, (option) => {
          return option.key === 'D';
        });
      },
      onHideColumn() {
        this.$refs.grid.showColumn('badge', false);
      },
    },
    created() {
      this.gridColumns0 = [
          {
            text: 'editable',
            datafield: 'editable',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {                
              }, this.dataset0, this.$refs.grid);              
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);              
            },
            width: '100px',            
          },
          {
            text: 'disable',
            datafield: 'disable',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '100px',            
          },
          {
            text: 'visibility',
            datafield: 'visibility',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '100px',            
          },
          {
            text: 'badge',
            datafield: 'badge',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellBadge(row, column, value, htmlElement, {
                optionList: this.stateOptionList,
                handler: this.onGridStateClicked,
                // checkEditableFunction: this.checkEditableFunction,
                // checkDisabledFunction: this.checkDisabledFunction,
                // checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            cellsalign,
            width: '100px',
          },
          {
            text: 'button',
            datafield: 'button',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
                handler: this.onGridButtonClicked,
                type: 'link',
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            cellsalign,
            width: '100px',
          },
          {
            text: 'buttonlist',
            datafield: 'buttonlist',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
                handler: this.onGridButtonClicked
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            cellsalign,
            // width: '150px',
          },
          {
            text: 'checkbox',
            datafield: 'checkbox',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellCheckbox(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            cellsalign,
            width: '100px',
          },
          {
            text: 'datepicker',
            datafield: 'datepicker',
            createwidget: (row, column, value, htmlElement) => {
              utils.getGridCellFactory().createCellDatePicker(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '150px',
          },
          {
            text: 'rangedatepicker',
            datafield: 'rangedatepicker',            
            createwidget: (row, column, value, htmlElement) => {
              utils.getGridCellFactory().createCellRangeDatePicker(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
                }, this.dataset0, this.$refs.grid,
              );
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '200px',
          },          
          {
            text: 'timepicker',
            datafield: 'timepicker',
            createwidget: (row, column, value, htmlElement) => {
              utils.getGridCellFactory().createCellTimePicker(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '150px',
          },
          {
            text: 'selectbox',
            datafield: 'selectbox',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
                optionList: this.customOptions,
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid);              
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '150px',
          },
          {
            text: 'multiselectbox',
            datafield: 'multiselectbox',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellMultiSelect(row, column, value, htmlElement, {
                optionList: this.multiSelectOptions,
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid);              
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '150px',
          },
          {
            text: 'segmentbox',
            datafield: 'segmentbox',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '100px',            
          },
          {
            text: 'treeitem',
            datafield: 'treeitem',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellTreeItem(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '100px',            
          },
          {
            text: 'statebutton',
            datafield: 'statebutton',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellStateButton(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
                handler: this.onGridButtonClicked,
                type: 'link',
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '200px',
          },  
          {
            text: 'textarea',
            datafield: 'textarea',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellTextarea(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableFunction,
                checkDisabledFunction: this.checkDisabledFunction,
                checkVisibilityFunction: this.checkVisibilityFunction,
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '200px',
          },
          // {
          //   text: 'textfield',
          //   datafield: 'textfield',
          //   createwidget: (row, column, value, htmlElement) => {
          //     const editorInstance = utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
          //       checkEditableFunction: this.checkEditableFunction,
          //       checkDisabledFunction: this.checkDisabledFunction,
          //       checkVisibilityFunction: this.checkVisibilityFunction,
          //       mask: 'currency',
          //     }, this.dataset0, this.$refs.grid);
          //   },
          //   initwidget(row, column, value, htmlElement) {
          //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          //   },
          //   width: '200px',
          // },
          // {
          //   text: 'textfieldwithbutton',
          //   datafield: 'textfieldwithbutton',
          //   createwidget: (row, column, value, htmlElement) => {
          //     const editorInstance = utils.getGridCellFactory().createCellTextFieldWithButton(row, column, value, htmlElement, {
          //       textFieldProps: {
          //         readonly: true,
          //         disabled: true,
          //         checkEditableFunction: this.checkEditableFunction,
          //       },
          //       buttonProps: {
          //         name: '버튼',
          //         disabled: false,
          //         checkEditableFunction: this.checkEditableFunction,
          //         style: 'comm_btn_InputScr',
          //       },
          //       handler: this.onTextfiledButtonClick,
          //       checkEditableFunction: this.checkEditableFunction,
          //       checkDisabledFunction: this.checkDisabledFunction,
          //       checkVisibilityFunction: this.checkVisibilityFunction,
          //     }, this.dataset0, this.$refs.grid);
          //   },
          //   initwidget(row, column, value, htmlElement) {
          //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          //   },
          //   width: '200px',
          // },
          // {
          //   text: 'textfieldwithlabel',
          //   datafield: 'textfieldwithlabel',
          //   createwidget: (row, column, value, htmlElement) => {
          //     const editorInstance = utils.getGridCellFactory().createCellTextFieldWithLabel(row, column, value, htmlElement, {
          //       textFieldProps: {
          //         readonly: false,
          //         disabled: false,
          //         trim: true,
          //         mask: 'number',
          //       },
          //       checkEditableFunction: this.checkEditableFunction,
          //       checkDisabledFunction: this.checkDisabledFunction,
          //       checkVisibilityFunction: this.checkVisibilityFunction,
          //     }, this.dataset0, this.$refs.grid);
          //   },
          //   initwidget(row, column, value, htmlElement) {
          //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          //   },
          //   width: '200px',
          // },
          // {
          //   text: 'label2',
          //   datafield: 'label2',
          //   createwidget: (row, column, value, htmlElement) => {
          //     const editorInstance = utils.getGridCellFactory().createCellLabel(row, column, value, htmlElement, {
          //       checkEditableFunction: this.checkEditableFunction,
          //       checkDisabledFunction: this.checkDisabledFunction,
          //       checkVisibilityFunction: this.checkVisibilityFunction,
          //     }, this.dataset0, this.$refs.grid);
          //   },
          //   initwidget(row, column, value, htmlElement) {
          //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          //   },
          //   width: '150px',
          // },
          // {
          //   text: 'tooltiplabel',
          //   datafield: 'tooltiplabel',
          //   createwidget: (row, column, value, htmlElement) => {
          //     const editorInstance = utils.getGridCellFactory().createCellLabel(row, column, value, htmlElement, {
          //       checkEditableFunction: this.checkEditableFunction,
          //       checkDisabledFunction: this.checkDisabledFunction,
          //       checkVisibilityFunction: this.checkVisibilityFunction,
          //     }, this.dataset0, this.$refs.grid);
          //   },
          //   initwidget(row, column, value, htmlElement) {
          //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          //   },
          //   width: '150px',
          // },          
          // {
          //   text: 'filterselectbox',
          //   datafield: 'filterselectbox',
          //   createwidget: (row, column, value, htmlElement) => {
          //     const editorInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
          //       optionList: this.customOptions,
          //       checkEditableFunction: this.checkEditableFunction,
          //       checkDisabledFunction: this.checkDisabledFunction,
          //       checkVisibilityFunction: this.checkVisibilityFunction,
          //       filterFunction: this.selectboxFilterFuntion,
          //     }, this.dataset0, this.$refs.grid);              
          //   },
          //   initwidget(row, column, value, htmlElement) {
          //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          //   },
          //   width: '150px',
          // },         
        ],       
        this.localdata = [],
        this.localdata0 = [{
            'badge': 'complete',
            'button': 'btn01',
            'buttonlist': [{
              label: 'link',
              key: 'btn01',
              type: 'link'
            },{
              label: 'sublink',
              key: 'btn02',
              type: 'sublink'
            },{
              label: 'label',
              key: 'btn03',
              type: 'label'
            },],
            'checkbox': 'Y',
            'datepicker': '2019-01-11',
            'rangedatepicker': '2019-01-11~2019-02-16',            
            'timepicker': '11:20',
            'selectbox': 'D',
            'multiselectbox': 'm1, m3',
            'segmentbox': 'Y',
            'statebutton': { text: '공지사항 새글이면 뉴아이콘이 붙어요', 'shownew': true, 'showattach': true },
            'editable': 'Y',
            'disable': 'N',
            'textarea': 'text area text 입니다.',
            'label2': 'label 입니다',
            'tooltiplabel': {
              'text': 'tooltip label입니다',
              'tooltip': 'tooltip입니다'
            },
            'textfield': '1234.55',
            'textfieldwithlabel' : {
              'inputText': '3000',
              'label': '100'
            },
            'textfieldwithbutton' : 'textfield 입니다',
            'filterselectbox': 'D',
            'visibility': 'Y',
            'treeitem' : {
              'checked': true,
              'depth': 1,
              'text': 'tree-item'
            }
          },                 
      ];
      // this.makeDataset();
    },    
    beforeDestroy() {
      this.newData = null;
    },
  };
</script>
<style scoped>
.my-button {
  border: 1px solid blue;
  width: 100px;
  height: 30px;
}
</style>
